// Backend refusals key "visits.<step>" (1-based); Laravel validation keys "visits.<index>.<field>" (0-based).
export type VisitErrorRef = { kind: 'step' | 'index'; n: number }

const STEP_KEY = /^visits\.(\d+)$/
const INDEX_KEY = /^visits\.(\d+)\./

export const visitErrorRef = (key: string): VisitErrorRef | null => {
  const step = STEP_KEY.exec(key)
  if (step) return Number(step[1]) > 0 ? { kind: 'step', n: Number(step[1]) } : null
  const index = INDEX_KEY.exec(key)
  return index ? { kind: 'index', n: Number(index[1]) } : null
}

// True when a 422 also refuses a field that is not a visit row (name, note, issue_ids).
export const hasNonVisitErrors = (errors: Record<string, string[]> | undefined): boolean =>
  Object.keys(errors ?? {}).some((key) => visitErrorRef(key) === null)

const REFUSED_VISIT = /^Visit (\d+)(?: on [^:]+| cannot be changed):\s*(.*)$/

// Reads "Visit N on <date>: text" and "Visit N cannot be changed: text" (N is 1-based).
export const refusedVisitOf = (message: string): { n: number; text: string } | null => {
  const match = REFUSED_VISIT.exec(message)
  return match ? { n: Number(match[1]), text: match[2] } : null
}
